<!--~
~ Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<mat-card>
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div class="measure-instructions">
            <span><b>Measure distance</b></span><br />
            <span>Click on the map to add to your path</span>
        </div>
        <div class="measure-close" (click)="close()">
            <mat-icon svgIcon="close"></mat-icon>
        </div>
    </div>
    @if (data$|async; as event) {
        <div>
            <b>Total distance:</b>
            <span class="measurement">{{ event.measurement.distance.label }}</span>
            <span class="alt-measurement">({{ event.altMeasurement.distance.label }})</span>
        </div>
        @if (event.measurement.area) {
            <div>
                <b>Total area:</b>
                <span class="measurement">{{ event.measurement.area.label }}</span>
                <span class="alt-measurement">({{ event.altMeasurement.area.label }})</span>
            </div>
        }
    }
</mat-card>